import { Component, OnDestroy, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TemplateNavigation } from 'src/app/core/models/store-templates/template-navigation';
import { PropertyFilter } from 'src/app/core/models/store-templates/property-filter';
import { TemplatesService } from 'src/app/core/services/api/templates.service'; 
import { Subscription } from 'rxjs'; 
import { TemplatePagesSelection } from 'src/app/core/models/store-templates/template-pages-selection';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dynamic-link-config',
  templateUrl: './dynamic-link-config.component.html',
  styleUrls: ['./dynamic-link-config.component.scss']
})
export class DynamicLinkConfigComponent implements OnInit {
 @Input() navItem:TemplateNavigation;
 @Input() navIndex:number;
 @Input() siteId:string;
 @Input() pagesListDll:Array<TemplatePagesSelection> = [];

  private pagesSub: Subscription; // To manage the subscription
  private isLoading = false; // Prevent multiple API calls

  targetList = [];

  plpFilterList = [];
  pdpFilterList = [];
  pagesToRemove = ["plp", "pdp"];
  menuDisplay = "horizontal";

  // Tooltip data using translation keys
  tooltipData = {
    label: "tooltip_label",
    target: "tooltip_target",
    path: "tooltip_path",
    filterBy: "tooltip_filter_by",
    url: "tooltip_url"
  };

  constructor(private route: ActivatedRoute,
              private tempalteService: TemplatesService,
              private cd: ChangeDetectorRef,
              public translate: TranslateService) {
    // Fallback if parent component did not pass siteId
    if (!this.siteId) {
      this.siteId = this.route.snapshot.paramMap.get('id');
    } 
  }

  ngOnInit(): void {
   // Subscribe to shared pages list
   this.pagesListDll = this.pagesListDll.filter(item=> !this.pagesToRemove.includes(item.key)) || [];
   
   // Initialize targetList with translated labels
   this.targetList = [
     { id: "PLP", label: this.translate.instant('menu_products_list_page') },
     { id: "PDP", label: this.translate.instant('menu_product_details_page') },
     { id: "INTERNAL_PAGE", label: this.translate.instant('menu_static_pages') },
     { id: "EXTERNAL_PAGE", label: this.translate.instant('menu_external_url') }
   ];

   // Initialize filter lists with translated labels
   this.plpFilterList = [
     { id: "CATEGORY_IDS", label: this.translate.instant('sh_categories') },
     { id: "PRODUCT_IDS", label: this.translate.instant('sb_products') }
   ];
   this.pdpFilterList = [
     { id: "PRODUCT_ID", label: this.translate.instant('sh_product') }
   ];

   // Update labels when language changes
   this.translate.onLangChange.subscribe(() => {
     this.targetList = [
       { id: "PLP", label: this.translate.instant('menu_products_list_page') },
       { id: "PDP", label: this.translate.instant('menu_product_details_page') },
       { id: "INTERNAL_PAGE", label: this.translate.instant('menu_static_pages') },
       { id: "EXTERNAL_PAGE", label: this.translate.instant('menu_external_url') }
     ];
     this.plpFilterList = [
       { id: "CATEGORY_IDS", label: this.translate.instant('sh_categories') },
       { id: "PRODUCT_IDS", label: this.translate.instant('sb_products') }
     ];
     this.pdpFilterList = [
       { id: "PRODUCT_ID", label: this.translate.instant('sh_product') }
     ];
   });
  }
  
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    if (this.pagesSub) {
      this.pagesSub.unsubscribe();
    }
  }

  onInternalPageChange(path){
    console.log("onInternalPageChange", path);
    this.navItem.path = path.path;
  }

  onTargetChange(targetValue, menuNav) {
    menuNav.target = targetValue.id;
    if (
      targetValue.id.indexOf("PLP") !== -1 ||
      targetValue.id.indexOf("PDP") !== -1
    ) {
      // Initialize filter with proper values instead of empty strings
      menuNav["filter"] = {
        data: [],
        by: targetValue.id.indexOf("PDP") !== -1 ? PropertyFilter.TypeEnum.PRODUCT_ID : PropertyFilter.TypeEnum.PRODUCT_IDS,
      };
    }
  }
  onFilterChange(value){
    this.navItem['filter'].by = value.id;
    this.navItem['filter'].data = [];
  }

  navigationTarget() {
    let selectList = [];
    let targetValues = Object.values(TemplateNavigation.TargetEnum).filter(value => value !== 'PROMOS');
    for (let index = 0; index < targetValues.length; index++) {
      this.targetList.push({id:targetValues[index], label:targetValues[index]});
    }
  }


  
}
